var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import AttachmentWarningToolTip from "../../components/articleattributes/attachmentwarningtooltip.vue";
import EditDataElement from "../../components/articleattributes/editdataelement.vue";
import { changeEntry, clone, isEqual, objEq, } from "../utilities/aux";
import { editDataValueMapTypeGuard, isAllowedAdditionalProcess, isArticleEditData, isAttachments, isComment, isCountersinking, isGrindingOption, isEditData, isFixedRotations, isFlipSideUsage, isMaterialWithGas, isMechanicalGrinding, isMultiplicity, isTestReport, isThreading, } from "../utilities/articleeditdata";
import { articleEditData, isAssembly, isManufacturablePart, isNotManufacturablePart, isPurchasedPart, isUserDefinedTube, } from "../utilities/documentdialog";
import { isValid, } from "../utilities/material";
import { getKeysOfObject, } from "../utilities/wsi4_interfaces";
import { isArray, isAttachment, isNumber, isString, isTubeCuttingParams, } from "../utilities/wsi4_typeguards";
import { isShopTappingNodeData, } from "../utilities/graph";
const generalEditDataKeys = [
    "articleName",
    "multiplicity",
];
const articleNumberEditDataKeys = [
    "articleExternalPartNumber",
    "articleExternalDrawingNumber",
    "articleExternalRevisionNumber",
];
const optionalEditDataKeys = [
    "mechanicalGrinding",
    "tapping",
    "countersinking",
    "threading",
];
const tubeSpecificEditDataKeys = [
    "tubeCuttingData",
    "tubeDimX",
];
const attachmentKeys = [
    "countersinking",
    "threading",
];
let ArticleEditForm = class ArticleEditForm extends Vue {
    constructor() {
        super(...arguments);
        this.inputData = [];
        this.inputDisabled = false;
    }
    changeData() { return this.inputData; }
    rotationChange(e) { return e; }
    articleDataChange() { return this.articleDataChanged; }
    submitForm() { this.changeData(); }
    reset() {
        this.inputData = clone(this.articleEditData, isArticleEditData);
        if (!objEq(this.inputData, this.articleEditData)) {
            throw Error("Error in resetting.");
        }
    }
    filterElements(keys) {
        return keys.reduce((arr, k) => {
            const f = this.elements.find(e => e.key === k);
            return f === undefined
                ? arr
                : [
                    ...arr,
                    f,
                ];
        }, []);
    }
    cssClass(element) {
        if (element === undefined) {
            return "article-edit-filler";
        }
        if (element.key === "testReport" || element.key === "flipSideUsage") {
            return "article-edit-form-checkbox-td";
        }
        return "article-edit-form-td";
    }
    compareArticleEditData(articleEditData, inputData) {
        return isEqual(articleEditData, inputData);
    }
    get articleEditData() { return articleEditData(this.projectEntry, this.shopConfig); }
    get changeFunctionMap() {
        return {
            articleExternalDrawingNumber: (name) => {
                if (!isString(name)) {
                    throw Error("Wrong type: name");
                }
                const index = this.inputData.findIndex(data => data.key === "articleExternalDrawingNumber");
                const data = this.inputData[index];
                if (!isString(data.value)) {
                    throw Error("Wrong type: input data name");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: name,
                }, isEditData);
            },
            articleExternalPartNumber: (name) => {
                if (!isString(name)) {
                    throw Error("Wrong type: name");
                }
                const index = this.inputData.findIndex(data => data.key === "articleExternalPartNumber");
                const data = this.inputData[index];
                if (!isString(data.value)) {
                    throw Error("Wrong type: input data name");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: name,
                }, isEditData);
            },
            articleExternalRevisionNumber: (name) => {
                if (!isString(name)) {
                    throw Error("Wrong type: name");
                }
                const index = this.inputData.findIndex(data => data.key === "articleExternalRevisionNumber");
                const data = this.inputData[index];
                if (!isString(data.value)) {
                    throw Error("Wrong type: input data name");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: name,
                }, isEditData);
            },
            articleName: (name) => {
                if (!isString(name)) {
                    throw Error("Wrong type: name");
                }
                const index = this.inputData.findIndex(data => data.key === "articleName");
                const data = this.inputData[index];
                if (!isString(data.value)) {
                    throw Error("Wrong type: input data name");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: name,
                }, isEditData);
            },
            attachments: (attachments) => {
                if (!isArray(attachments, isAttachment)) {
                    throw Error("Wrong type: attachments");
                }
                const index = this.inputData.findIndex(data => data.key === "attachments");
                const data = this.inputData[index];
                if (!isAttachments(data.value)) {
                    throw Error("Wrong type: input attachments");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: {
                        ...data.value,
                        attachments: attachments,
                    },
                }, isEditData);
            },
            comment: (comment) => {
                if (!isString(comment)) {
                    throw Error("Wrong type: comment");
                }
                const index = this.inputData.findIndex(data => data.key === "comment");
                const data = this.inputData[index];
                if (!isComment(data.value)) {
                    throw Error("Wrong type: input data comment");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: {
                        ...data.value,
                        comment: comment,
                    },
                }, isEditData);
            },
            countersinking: (numCounterSinks) => {
                if (!isMultiplicity(numCounterSinks)) {
                    throw Error("Wrong type: counterSinks");
                }
                const index = this.inputData.findIndex(data => data.key === "countersinking");
                const data = this.inputData[index];
                if (!isCountersinking(data.value)) {
                    throw Error("Wrong type: input data countersinking");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: {
                        ...data.value,
                        numCounterSinks: numCounterSinks,
                    },
                }, isEditData);
            },
            fixedRotations: (rotation) => {
                if (!isArray(rotation, isNumber)) {
                    throw Error("Wrong type: rotation");
                }
                const index = this.inputData.findIndex(data => data.key === "fixedRotations");
                const data = this.inputData[index];
                if (!isFixedRotations(data.value)) {
                    throw Error("Wrong type: input rotation");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: {
                        ...data.value,
                        rotations: rotation,
                    },
                }, isEditData);
                this.rotationChange(rotation);
            },
            flipSideUsage: () => {
                const index = this.inputData.findIndex(data => data.key === "flipSideUsage");
                const data = this.inputData[index];
                if (!isFlipSideUsage(data.value)) {
                    throw Error("Wrong type: input flip side");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: {
                        ...data.value,
                        flipSide: !data.value.flipSide,
                    },
                }, isEditData);
            },
            materialWithGas: (material) => {
                if (!isMaterialWithGas(material)) {
                    throw Error("Wrong type: material");
                }
                const index = this.inputData.findIndex(data => data.key === "materialWithGas");
                const data = this.inputData[index];
                if (!isMaterialWithGas(data.value)) {
                    throw Error("Wrong type: input material");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: material,
                }, isEditData);
            },
            mechanicalGrinding: (grindingOption) => {
                if (!isGrindingOption(grindingOption)) {
                    throw Error("Wrong type: grindingOption");
                }
                const index = this.inputData.findIndex(data => data.key === "mechanicalGrinding");
                const data = this.inputData[index];
                if (!isMechanicalGrinding(data.value)) {
                    throw Error("Wrong type: input grinding");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: {
                        ...data.value,
                        option: grindingOption,
                    },
                }, isEditData);
            },
            multiplicity: (m) => {
                if (!isMultiplicity(m)) {
                    throw Error("Wrong type: multiplicity");
                }
                const index = this.inputData.findIndex(data => data.key === "multiplicity");
                const data = this.inputData[index];
                if (data === undefined) {
                    return;
                }
                if (!isMultiplicity(data.value)) {
                    throw Error("Wrong type: input multiplicity");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: m,
                }, isEditData);
            },
            tapping: (chosenTapping) => {
                const index = this.inputData.findIndex(data => data.key === "tapping");
                const data = this.inputData[index];
                if (!isShopTappingNodeData(chosenTapping)) {
                    throw Error("Wrong type: input tapping");
                }
                if (chosenTapping.candidates.length > 0) {
                    this.inputData = changeEntry(this.inputData, index, {
                        ...data,
                        value: chosenTapping,
                    }, isEditData);
                }
            },
            testReport: () => {
                const index = this.inputData.findIndex(data => data.key === "testReport");
                const data = this.inputData[index];
                if (!isTestReport(data.value)) {
                    throw Error("Wrong type: input testReport");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: {
                        ...data.value,
                        required: !data.value.required,
                    },
                }, isEditData);
            },
            thickness: (thickness) => {
                if (!isNumber(thickness)) {
                    throw Error("Wrong type: thickness");
                }
                const index = this.inputData.findIndex(data => data.key === "thickness");
                const data = this.inputData[index];
                if (!isNumber(data.value)) {
                    throw Error("Wrong type: input thickness");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: thickness,
                }, isEditData);
            },
            threading: (numThreads) => {
                if (!isMultiplicity(numThreads)) {
                    throw Error("Wrong type: Threads");
                }
                const index = this.inputData.findIndex(data => data.key === "threading");
                const data = this.inputData[index];
                if (!isThreading(data.value)) {
                    throw Error("Wrong type: input data threading");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: {
                        ...data.value,
                        numThreads: numThreads,
                    },
                }, isEditData);
            },
            tubeDimX: (tubeDimX) => {
                if (!isNumber(tubeDimX)) {
                    throw Error("Wrong type: tubeDimX.");
                }
                const index = this.inputData.findIndex(data => data.key === "tubeDimX");
                const data = this.inputData[index];
                if (data === undefined) {
                    return;
                }
                if (!isNumber(data.value)) {
                    throw Error("Wrong type: input data tubeDimX");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: tubeDimX,
                }, isEditData);
            },
            tubeCuttingData: (tubeCuttingData) => {
                if (!isTubeCuttingParams(tubeCuttingData)) {
                    throw Error("Wrong type: tubeCuttingData.");
                }
                const index = this.inputData.findIndex(data => data.key === "tubeCuttingData");
                const data = this.inputData[index];
                if (!isTubeCuttingParams(data.value)) {
                    throw Error("Wrong type: input data tubeCuttingData");
                }
                this.inputData = changeEntry(this.inputData, index, {
                    ...data,
                    value: tubeCuttingData,
                }, isEditData);
            },
        };
    }
    get unfilteredElementsShown() {
        if (isPurchasedPart(this.projectEntry)) {
            return [];
        }
        if (isNotManufacturablePart(this.projectEntry)) {
            return [
                ...generalEditDataKeys,
                ...articleNumberEditDataKeys,
            ];
        }
        if (isAssembly(this.projectEntry)) {
            return generalEditDataKeys;
        }
        if (isUserDefinedTube(this.projectEntry)) {
            return [
                ...generalEditDataKeys,
                ...articleNumberEditDataKeys,
                "attachments",
                ...tubeSpecificEditDataKeys,
            ];
        }
        return getKeysOfObject(this.changeFunctionMap)
            .filter(a => (!optionalEditDataKeys.some(e => a === e) && !tubeSpecificEditDataKeys.some(e => a === e)) || isAllowedAdditionalProcess(a, this.shopConfig));
    }
    get elementsShown() {
        return this.unfilteredElementsShown.filter((key) => this.networkBroker.configuration.editDataConfiguration[key].visible);
    }
    get rowIndices() {
        return [
            ...this.elementsShown.map(key => this.networkBroker.configuration.editDataConfiguration[key].rowPriority),
            ...this.networkBroker.configuration.fillerElements.map(e => e.rowPriority),
        ]
            .sort((a, b) => a - b)
            .filter((n, index, self) => self.findIndex(i => i === n) === index);
    }
    get columnIndices() {
        return [
            ...this.elementsShown.map(key => this.networkBroker.configuration.editDataConfiguration[key].columnPriority),
            ...this.networkBroker.configuration.fillerElements.map(e => e.columnPriority),
        ]
            .sort((a, b) => a - b)
            .filter((n, index, self) => self.findIndex(i => i === n) === index);
    }
    get elementTable() {
        const table = [];
        for (const rowIndex of this.rowIndices) {
            const row = [];
            for (const columnIndex of this.columnIndices) {
                const key = this.elementsShown.find(k => this.networkBroker.configuration.editDataConfiguration[k].rowPriority === rowIndex
                    && this.networkBroker.configuration.editDataConfiguration[k].columnPriority === columnIndex);
                if (key === undefined) {
                    const filler = this.networkBroker.configuration.fillerElements.find(e => e.columnPriority === columnIndex && e.rowPriority === rowIndex);
                    if (filler !== undefined) {
                        row.push(undefined);
                    }
                }
                else {
                    const e = this.elements.find(l => l.key === key);
                    if (e !== undefined) {
                        row.push(e);
                    }
                }
            }
            table.push(row);
        }
        return table;
    }
    get emptyForm() {
        return isPurchasedPart(this.projectEntry);
    }
    get elements() {
        if (this.emptyForm) {
            return [];
        }
        return this.elementsShown
            .reduce((res, key) => {
            const data = this.inputData.find(data => data.key === key);
            if (data === undefined) {
                if (key === "thickness") {
                    if (!isManufacturablePart(this.projectEntry)) {
                        throw Error("Wrong type: disabled thickness");
                    }
                    return [
                        ...res,
                        {
                            key: key,
                            value: this.projectEntry.thickness,
                            disabled: true,
                        },
                    ];
                }
                if (key === "multiplicity") {
                    return [
                        ...res,
                        {
                            key: key,
                            value: this.projectEntry.multiplicity,
                            disabled: true,
                        },
                    ];
                }
                if (key === "tubeDimX") {
                    if (!isUserDefinedTube(this.projectEntry)) {
                        throw Error("Wrong type : tubeDimX.");
                    }
                    return [
                        ...res,
                        {
                            key: key,
                            value: this.projectEntry.dimX,
                            disabled: true,
                        },
                    ];
                }
                if (key !== "testReport" && key !== "fixedRotations" && key !== "tapping" && key !== "tubeCuttingData") {
                    throw Error("Disabled value not handled: " + key);
                }
                else {
                    return res;
                }
            }
            else {
                return [
                    ...res,
                    {
                        key: data.key,
                        value: data.value,
                        disabled: false,
                    },
                ];
            }
        }, []);
    }
    get thickness() {
        const t = this.elements.find(e => e.key === "thickness");
        if (t === undefined) {
            return isManufacturablePart(this.projectEntry) ? this.projectEntry.thickness : undefined;
        }
        if (!isNumber(t.value)) {
            throw Error("Wrong type: thickness");
        }
        return t.value;
    }
    get material() {
        const m = this.elements.find(e => e.key === "materialWithGas");
        if (m === undefined) {
            return undefined;
        }
        if (!isMaterialWithGas(m.value)) {
            throw Error("Wrong type: material");
        }
        return m.value;
    }
    get errors() {
        return getKeysOfObject(editDataValueMapTypeGuard)
            .reduce((res, key) => {
            const data = this.inputData.find(d => d.key === key);
            if (data === undefined) {
                return res;
            }
            else if (key === "multiplicity" && data.value <= 0) {
                return [
                    ...res,
                    {
                        key: "multiplicity",
                        error: "positiveNumberInvalid",
                    },
                ];
            }
            else if (key === "articleName" && data.value === "") {
                return [
                    ...res,
                    {
                        key: "articleName",
                        error: "nameInvalid",
                    },
                ];
            }
            else if (key === "materialWithGas") {
                if (!isMaterialWithGas(data.value)) {
                    throw new Error("Wrong Type: " + data.key);
                }
                if (this.thickness === undefined) {
                    throw Error("Missing thickness");
                }
                if (!isValid(this.shopConfig, [this.thickness], data.value.material.identifier, data.value.cuttingGasId)) {
                    return [
                        ...res,
                        {
                            key: "materialWithGas",
                            error: "materialSelection",
                        },
                    ];
                }
            }
            else if (key === "fixedRotations") {
                if (!isFixedRotations(data.value)) {
                    throw Error("Wrong type: " + data.key);
                }
                if (Math.min(...data.value.rotations) < 0 || data.value.rotations[0] >= 180.) {
                    return [
                        ...res,
                        {
                            key: "fixedRotations",
                            error: "rotationInvalid",
                        },
                    ];
                }
            }
            else if (key === "countersinking" && isCountersinking(data.value)) {
                if (!isNumber(data.value.numCounterSinks) || data.value.numCounterSinks < 0) {
                    return [
                        ...res,
                        {
                            key: "countersinking",
                            error: "counterSinkingInvalid",
                        },
                    ];
                }
                else if (data.value.numCounterSinks > 0 && this.attachmentsLength === 0) {
                    return [
                        ...res,
                        { key: "countersinking", error: "attachmentsWarning" },
                    ];
                }
            }
            else if (key === "threading" && isThreading(data.value)) {
                if (!isNumber(data.value.numThreads) || data.value.numThreads < 0) {
                    return [
                        ...res,
                        { key: "threading", error: "threadingInvalid" },
                    ];
                }
                else if (data.value.numThreads > 0 && this.attachmentsLength === 0) {
                    return [
                        ...res,
                        { key: "threading", error: "attachmentsWarning" },
                    ];
                }
            }
            else if (key === "tubeCuttingData") {
                if (!isTubeCuttingParams(data.value) || data.value.tubeId === "") {
                    return [
                        ...res,
                        {
                            key: "tubeCuttingData",
                            error: "tubeIdInvalid",
                        },
                    ];
                }
            }
            return res;
        }, []);
    }
    get submittable() { return Object.keys(this.errors).length === 0 && this.articleDataChanged; }
    get articleDataChanged() { return !this.compareArticleEditData(this.articleEditData, this.inputData); }
    get attachmentsLength() {
        const att = this.inputData.find(elem => elem.key === "attachments");
        if (att === undefined) {
            return 0;
        }
        if (!isAttachments(att.value)) {
            throw Error("Wrong type of threading");
        }
        return att.value.attachments.length;
    }
    get attachmentWarning() { return attachmentKeys.some(a => this.elementsShown.some(e => e === a)); }
    created() { this.inputData = clone(this.articleEditData, isArticleEditData); }
    onProjectEntryChanged() { this.inputData = clone(this.articleEditData, isArticleEditData); }
    onArticleDataChanged() { this.articleDataChange(); }
};
__decorate([
    Prop({ required: true })
], ArticleEditForm.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], ArticleEditForm.prototype, "projectEntry", void 0);
__decorate([
    Inject()
], ArticleEditForm.prototype, "i18n", void 0);
__decorate([
    Inject()
], ArticleEditForm.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], ArticleEditForm.prototype, "changeData", null);
__decorate([
    Emit()
], ArticleEditForm.prototype, "rotationChange", null);
__decorate([
    Emit()
], ArticleEditForm.prototype, "articleDataChange", null);
__decorate([
    Watch("projectEntry")
], ArticleEditForm.prototype, "onProjectEntryChanged", null);
__decorate([
    Watch("articleDataChanged")
], ArticleEditForm.prototype, "onArticleDataChanged", null);
ArticleEditForm = __decorate([
    Component({
        components: {
            EditDataElement,
            AttachmentWarningToolTip,
        },
        name: "ArticleEditForm",
    })
], ArticleEditForm);
export default ArticleEditForm;
